var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "horizontal-item p-3" }, [
        _c("div", { staticClass: "d-md-flex justify-content-between" }, [
          _c("div", { staticClass: "d-md-flex" }, [
            _c(
              "div",
              { staticClass: "position-relative mb-2 mb-md-0" },
              [
                _c("small-carousel", {
                  attrs: {
                    images: _vm.images,
                    "show-indicators": false,
                    height: "185px"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "position-relative" }, [
              _c("div", [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticClass: "date-info" }, [
                    _c("h1", { staticClass: "m-0" }, [_vm._v(_vm._s(_vm.day))]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "text-uppercase m-0" }, [
                      _vm._v(_vm._s(_vm.month))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-info" }, [
                    _c(
                      "h6",
                      { staticClass: "mb-0 text-uppercase text-primary" },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.categoria) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("h3", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm.titolo))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2" }, [
                _c("p", { staticClass: "mb-1 text-uppercase text-nowrap" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../../assets/images/svg/black/icone_durata.svg"),
                      height: "12px"
                    }
                  }),
                  _vm._v(" "),
                  _c("small", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.durata) +
                          " " +
                          _vm._s(_vm.durata > 1 ? "giorni" : "giorno")
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "overflowParagraph" }, [
                  _vm._v(_vm._s(_vm.descrizione))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { class: "" + (_vm.isMobile ? "text-center" : "") }, [
            _c("div", { staticClass: "position-relative" }, [
              _c("h5", [_vm._v("a partire da")]),
              _vm._v(" "),
              _c("h1", { staticClass: "currency" }, [
                _vm._v(_vm._s(_vm.prezzo) + " €")
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                class: "btn btn-primary px-5 " + (_vm.isMobile ? "w-100" : ""),
                attrs: { id: "scegliExperience" },
                on: { click: _vm.onOpenDetail }
              },
              [_vm._v("\n          scegli\n        ")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("ModalExperienceDetail", {
        ref: "modalExperienceDetail",
        attrs: { value: _vm.value, services: _vm.services },
        on: { select: _vm.onSelect }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4a35fbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4a35fbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/experience/HorizontalItemExperience.vue
// module id = null
// module chunks = 